export class BaseEntity {
  id;
  seo;
  constructor(data) {
    this.id = data.id;
    this.seo = {
      title: data.seo_title,
      description: data.seo_description,
      keywords: data.seo_keywords,
      canonical: data.seo_canonical
    };
  }
}
